import React from 'react';
import styles from '../Footer/footer.module.css';
import { Col, Row } from 'react-bootstrap';
import { graphql, Link, useStaticQuery } from 'gatsby';
import SiteMap from '../../Constants/SiteMap';
import HelpfulLinks from '../../Constants/HelpfulLinks';
import { v4 as uuidv4 } from 'uuid';
import Img from 'gatsby-image';

const query = graphql`
	query {
		allContentfulHomePage {
			nodes {
				emailAddress
				phoneNumber
				linkToFacebook
				linkToInstagram
				aboutUsText {
					aboutUsText
				}
				paymentProviderLogos {
					fluid {
						...GatsbyContentfulFluid
					}
					title
				}
			}
		}
	}
`;

const Footer = () => {
	const data = useStaticQuery(query);
	const { emailAddress, phoneNumber, linkToFacebook, linkToInstagram } = data.allContentfulHomePage.nodes[0];

	return (
		<footer className={styles.footer} id="footer">
			<Row className={styles.footerHolder}>
				<Col xs={12} md={4}>
					<h3>ABOUT US</h3>
					<p>{data.allContentfulHomePage.nodes[0].aboutUsText.aboutUsText}</p>
				</Col>
				<Col xs={12} md={2}>
					<h3>SITEMAP</h3>
					<ul className={styles.list}>
						{SiteMap.map((link) => (
							<li key={uuidv4()}>
								<Link className={styles.link} to={link.path}>
									{link.text}
								</Link>
							</li>
						))}
					</ul>
				</Col>
				<Col xs={12} md={2}>
					<h3>HELPFUL LINKS</h3>
					<ul className={styles.list}>
						{HelpfulLinks.map((link) => (
							<li key={uuidv4()}>
								<Link className={styles.link} to={link.path}>
									{link.text}
								</Link>
							</li>
						))}
					</ul>
				</Col>
				<Col xs={12} md={2}>
					<h3>CONTACT US</h3>
					<ul className={styles.list}>
						<li>
							<a href={linkToFacebook} className={styles.link} rel="noopener noreferrer" target="_blank">
								FACEBOOK
							</a>
						</li>
						<li>
							<a href={linkToInstagram} className={styles.link} rel="noopener noreferrer" target="_blank">
								INSTAGRAM
							</a>
						</li>
						<li>{phoneNumber}</li>
						<li>
							<a
								href={`mailto:${emailAddress}`}
								className={styles.link}
								rel="noopener noreferrer"
								target="_blank"
							>
								E-MAIL
							</a>
						</li>
					</ul>
				</Col>
				<Col xs={12}>
					<Row className={styles.footerBottom}>
						<Col xs={12} md={6}>
							<Row>
								{data.allContentfulHomePage.nodes[0].paymentProviderLogos.map((logo) => (
									<Col xs={2} sm={1} md={2} lg={1}>
										<Img fluid={logo.fluid} alt={logo.title} />
									</Col>
								))}
							</Row>
						</Col>
						<Col xs={12} md={6} className={styles.credit}>
							<a
								href="http://kishokanth.com/"
								className={styles.link}
								rel="noopener noreferrer"
								target="_blank"
							>
								DEVELOPED BY KISHOKANTH
							</a>
						</Col>
					</Row>
				</Col>
			</Row>
		</footer>
	);
};

export default Footer;
